var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1.25,
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    transform: "translate(1.25 1.25)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.37025 11.74275h-1.86075c-.4155 0-.75225-.33675-.75225-.75225v-1.8615c0-.1995-.0795-.39075-.2205-.53175l-1.31625-1.31625c-.294-.294-.294-.77025 0-1.0635l1.32975-1.32975c.13275-.13275.207-.312.207-.4995v-1.87875c0-.4155.33675-.75225.75225-.75225h1.8615c.1995 0 .39075-.0795.53175-.2205l1.31625-1.31625c.294-.294.77025-.294 1.0635 0l1.31625 1.31625c.141.141.33225.2205.53175.2205h1.8615c.4155 0 .75225.33675.75225.75225v1.8615c0 .1995.0795.39075.2205.53175l1.31625 1.31625c.294.294.294.77025 0 1.0635l-1.31625 1.31625c-.141.141-.2205.33225-.2205.53175v1.8615c0 .4155-.33675.75225-.75225.75225h-1.8615c-.1995 0-.39075.0795-.53175.2205l-1.31625 1.31625c-.294.294-.77025.294-1.0635 0l-1.31625-1.31625c-.14175-.14325-.333-.222-.5325-.222z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9 5.625-2.8125 2.8125-1.6875-1.6875"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCheck);
export default __webpack_public_path__ + "static/media/star-check.d5fd077e818591d39aea7db0011eee9b.svg";
export { ForwardRef as ReactComponent };